import { AppError, ErrorCode } from "@newxsystems/types";
import { ServerContext } from "../context/index.js";
import { mapComponentTree } from "../utils/map-component-tree.js";
import { resolveComponentLoaders, flattenPageComponents } from "../utils/resolve-component-loaders.js";
function createPageRenderContext({
  factory,
  pageContext
}) {
  const context = new ServerContext({ factory });
  context.setPageContext(pageContext);
  return context;
}
async function mapLayoutSections(page, ctx, sdk) {
  return Promise.all(
    (page.items ?? []).map(async (layoutSection) => ({
      ...layoutSection,
      components: await mapComponentTree(layoutSection.components, ctx, sdk)
    }))
  );
}
async function preparePageStructure({
  context,
  factory,
  loaderFactory,
  mapProps = true,
  page,
  pageContext,
  queryClient,
  runLoaders = true,
  sdk
}) {
  let ctx = context;
  if (!ctx) {
    if (!factory || !pageContext) {
      throw new AppError({
        code: ErrorCode.ENGINE_MISSING_FACTORY,
        message: "Preparing a page structure requires either a render context or both factory and pageContext.",
        hint: "Pass the existing FE engine context, or create one from the app route loader with createPageRenderContext()."
      });
    }
    ctx = createPageRenderContext({ factory, pageContext });
  }
  const normalizedPage = mapProps ? {
    ...page,
    items: await mapLayoutSections(page, ctx, sdk)
  } : page;
  const loaderResults = runLoaders ? await Promise.allSettled(
    resolveComponentLoaders(ctx, normalizedPage, queryClient, loaderFactory) ?? []
  ) : [];
  const cacheTags = [
    ...new Set(
      flattenPageComponents(ctx, normalizedPage).flatMap(
        (component) => ctx.factory.resolveFlags(component.name)?.cache?.tags ?? []
      )
    )
  ];
  return {
    cacheTags,
    loaderResults,
    page: normalizedPage,
    pageContext: pageContext ?? ctx.getPageContext()
  };
}
export {
  createPageRenderContext,
  preparePageStructure
};
//# sourceMappingURL=prepare-page-structure.js.map
